export function noLeadingTrailingSpace(fieldValue: string) {
  return fieldValue && /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/.test(fieldValue)
    ? 'Cannot have space as first and last character'
    : undefined;
}
